module.exports = __webpack_public_path__ + "img/time.8dbe84a3.svg";